// @need-translate
import {useCallback} from 'react';
import {requestContext} from '../../common/requestContext';
import {twMerge} from '../../common/twMerge';
import useTypedDispatch from '../../common/useTypedDispatch';
import useTypedSelector from '../../common/useTypedSelector';
import {useDialog} from '../../dialog/useDialog.hook';
import {ViewerSettingContainer} from '../../domain/content/[seriesId]/viewer/[productId]/container/ViewerSettingContainer';
import {setCurrentViewerGuide} from '../../domain/content/[seriesId]/viewer/[productId]/state/viewerInfoSlice';
import {setIsViewerMenuExposed} from '../../domain/content/[seriesId]/viewer/[productId]/state/viewerMenuSlice';
import {showViewerGuide} from '../../domain/content/[seriesId]/viewer/[productId]/util/showViewerGuide';
import {ONLY_DATA_CONFIG} from '../../reactQuery/constant';
import {useSinglePreviewQuery} from '../../wrapper';
import {useViewerInfoQuery} from '../../wrapper/viewerWrapper';
import {MobileViewerHeader} from '../organisms/MobileViewerHeader/MobileViewerHeader';
import {MobileLayoutViewerTitleHeader} from './MobileLayoutViewerTitleHeader';

export function MobileLayoutTextViewerPreviewHeader({
  seriesId,
  productId,
}: {
  seriesId: number;
  productId: number;
}) {
  const dispatch = useTypedDispatch();

  const result = useViewerInfoQuery({seriesId, productId}, ONLY_DATA_CONFIG);
  const {error, data: viewerData} = result;

  const {prevViewerGuide, currentViewerGuide} = useTypedSelector(state => ({
    prevViewerGuide: state.viewerInfo.prevViewerGuide,
    currentViewerGuide: state.viewerInfo.currentViewerGuide,
  }));
  const {isViewerMenuExposed} = useTypedSelector(state => ({
    isViewerMenuExposed: state.viewerMenu.isExposed,
  }));

  const {isMobile} = requestContext.requestInfo.display;

  const showViewerGuideWhenDifferent = useCallback(() => {
    if (currentViewerGuide && prevViewerGuide !== currentViewerGuide) {
      showViewerGuide({viewerGuideType: currentViewerGuide});
    }
    dispatch(setCurrentViewerGuide(currentViewerGuide));
  }, [currentViewerGuide, prevViewerGuide, dispatch]);

  const {DialogWrapper, Dialog, showDialog} = useDialog({
    isMobile,
    onClose: showViewerGuideWhenDifferent,
  });

  const handleClickMobileSettingButton = useCallback(() => {
    //모바일의 경우 뷰어 설정이 켜졌을 때 뷰어 메뉴가 꺼지게
    dispatch(setIsViewerMenuExposed({isExposed: false}));
    showDialog();
  }, [dispatch, showDialog]);

  const showNotSupportAlert = useCallback(() => {
    window.alert('지원하지 않습니다.');
  }, []);

  const singlePreviewResult = useSinglePreviewQuery({productId});
  const {data: singlePreviewData} = singlePreviewResult;

  const productTitle = singlePreviewData?.singlePreview?.title;

  if (error || !productId) {
    return <MobileLayoutViewerTitleHeader />;
  }
  if (!viewerData || error || !productId) {
    return (
      <MobileLayoutViewerTitleHeader
        title={productTitle}
        onClickContentHome={showNotSupportAlert}
      />
    );
  }
  return (
    <>
      <div className={twMerge('w-full', !isViewerMenuExposed && 'hidden')}>
        <MobileViewerHeader
          className="z-150"
          title={viewerData.item.title}
          isTextViewer={true}
          hasSetting={true}
          onClickContentsHomeButton={showNotSupportAlert}
          onClickSettingButton={handleClickMobileSettingButton}
        />
      </div>
      <DialogWrapper isShadow={true} className="z-150" closeWhenSwipe>
        <Dialog.Dimmed opacity={0} />
        <Dialog.ViewerSetting>
          <ViewerSettingContainer
            seriesId={seriesId ?? -1}
            productId={productId ?? -1}
            slideType={viewerData.item.slideType}
          />
        </Dialog.ViewerSetting>
      </DialogWrapper>
    </>
  );
}
